<template>
  <div id="preAdd-publisher">
    <ipub-model :title="'Set Pre-Publisher’s Volume'"
                width="900px"
                :visable="isVisable"
                @confirm="confirm"
                confirmText="Confirm"
                @cancel="cancel">
      <div class="ipub-p1">Choose Volume <font class="key-color">*</font>
      </div>
      <ipub-select v-model="params.volumeIdList"
                   mode="multiple"
                   placeholder="Select Article Status">
        <ipub-select-option v-for="(value) in volumeList"
                            :key="value.id"
                            :value="value.id">
          Volume {{ value.code }}
        </ipub-select-option>
      </ipub-select>
    </ipub-model>
  </div>
</template>
<style lang="scss" scoped>
</style>
<script>
import { volume } from '@/api/vissue'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false
    },
    volumeList: {
      type: Array,
      default () {
        return []
      }
    },
    journalId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      params: {}
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    async confirm () {
      if (!this.params.volumeIdList) {
        this.$message.error({
          title: 'Error',
          content:
            'Volume cannot be empty!'
        })
        return
      }
      this.params.journalId = this.journalId
      await volume.Prepublisher(this.params)
      this.$emit('confirm')
    }
  }
}
</script>
